import React, { useEffect, useRef, useState } from "react";
import { Button, Card, CardBody, CardFooter, CardHeader, Label, Row } from "reactstrap";
import BlkFormik from "../util/BlkFormik";
import { Form } from "formik";
import { BlkField } from "../coms/BlkField";
import axios from "axios";
import { routes } from "../gen/General";
import { Link, useHistory } from "react-router-dom";
import Alerts from "../util/Alerts";
import logo from "../assets/img/prodeseg_login.png";
import { useSearchParam } from "../util/useLocation";

export const Registro = () => {
    const alert = useRef();
    const [data, setData] = useState({ nmContacto: "", correo: "" });
    const [step2, setStep2] = useState(false);
    const [res, setRes] = useState({ exist: false, count: 0 });
    const history = useHistory();
    const valida = useSearchParam("valida");
    const hide = useSearchParam("hide");

    useEffect(() => {
        if (!valida) return;
        const datos = atob(valida).split("xxx666xxx");
        setData({ ...data, correo: datos[1], code: hide ? "" : datos[0], hide: !hide });
        setStep2(true);
        setRes({ ...res, count: 1 });
    }, [valida]);

    const onSubmit = (newValues, { setSubmitting }) => {
        setRes({ exist: false, count: 0 });
        axios
            .post(routes.api + "/public/registrar-usuario", newValues)
            .then(resp => {
                return new Promise(function (resolve, reject) {
                    axios
                        .post(routes.apiVam + "/public/registrar-usuario", newValues)
                        .then(resp2 => {
                            resolve([resp.data, resp2.data]);
                        })
                        .catch(error => {
                            reject(error);
                        });
                });
            })
            .then(([resp1, resp2]) => {
                setRes({ exist: resp1.exist, count: resp1.count + resp2.count });
                setStep2(true);
                setData(newValues);
                setSubmitting(false);
            })
            .catch(err => {
                setSubmitting(false);
                alert.current.handle_error(err);
            });
    };

    const onSubmitPass = (values, { setSubmitting }) => {
        axios
            .post(routes.api + "/public/registrar-usuario/validar", values)
            .then(resp => {
                if (resp.data.done) {
                    setTimeout(() => {
                        history.push("/");
                    }, 2200);
                } else {
                    throw new Error("No se pudo validar");
                }
            })
            .catch(err => {
                setSubmitting(false);
                alert.current.handle_error(err);
            });
    };

    const UsuarioExiste = () => {
        return (
            <div className={"d-flex justify-content-end flex-column align-items-center align-items-md-end"}>
                <Card className="card-login card-plain">
                    <CardHeader>
                        <h3 className="mb-0 text-center text-white py-4">Registro</h3>
                    </CardHeader>
                    <CardBody className={"pb-0 text-center"}>
                        <p className={"m-5 text-center text-white"}>
                            Usuario ya existe, ingrese con su email y contraseña establecida.
                        </p>
                    </CardBody>
                    <CardFooter className="pt-0 mt-5">
                        <h6>
                            <Link to="/" className="mb-3 py-1 text-primary btn btn-white btn-lg btn-block">
                                Iniciar sesión
                            </Link>
                        </h6>

                        <h6 className={"text-center"}>
                            <Link to="/" className="link footer-link">
                                ¿Olvidó su Contraseña?
                            </Link>
                        </h6>
                    </CardFooter>
                </Card>
            </div>
        );
    };

    const AsociadosEmpty = () => {
        return (
            <div className={"d-flex justify-content-end flex-column align-items-center align-items-md-end"}>
                <Card className="card-login card-plain">
                    <CardBody className={"pb-0 text-center"}>
                        <br />
                        <p className={"container text-justify text-white"}>
                            ¡Ups!, No podemos encontrar ningún cliente asociado al correo que ingresaste. Si consideras
                            que esto es un error, por favor envianos un email con tus datos de contacto a:{" "}
                            <b>
                                <a className="text-white" href={"mailto:infoportal@prodeseg.com"}>
                                    infoportal@prodeseg.com{" "}
                                </a>
                            </b>
                            y nuestro equipo te dará soporte.
                        </p>
                    </CardBody>
                    <CardFooter className="pt-0 mt-5">
                        <h6>
                            <Link to="/" className="mb-3 py-1 text-primary btn btn-white btn-lg btn-block">
                                Iniciar sesión
                            </Link>
                        </h6>
                    </CardFooter>
                </Card>
            </div>
        );
    };

    return (
        <div className={"col-12 col-md-7 bg-green-blur"}>
            <div className="logo-wrp">
                <img src={logo} alt="now-logo" />
            </div>
            <Alerts ref={alert} />
            {!step2 && <FormRegistro data={data} onSubmit={onSubmit} />}
            {step2 && res.exist && <UsuarioExiste />}
            {step2 && !res.exist && res.count > 0 && <FormValida data={data} onSubmitPass={onSubmitPass} />}
            {step2 && !res.exist && res.count === 0 && <AsociadosEmpty />}
        </div>
    );
};

const FormRegistro = ({ data, onSubmit }) => {
    const existe = useSearchParam("existe");

    return (
        <BlkFormik initialValues={data} onSubmit={onSubmit} enableReinitialize={true} validateOnChange={false}>
            {({ isSubmitting, submitForm }) => (
                <Form className={"d-flex justify-content-end flex-column align-items-center align-items-md-end"}>
                    <Card className="card-login card-plain">
                        <CardHeader>
                            <h3 className="mb-0 text-center text-white py-4">Registro</h3>
                        </CardHeader>
                        <CardBody className={"pb-0 text-center"}>
                            <p className={"text-white"}>{existe && "No se encontró un usuario asociado.\n"}</p>
                            <p className={"text-white"}>
                                Ingresa tu nombre y correo electrónico para activar tu usuario.{" "}
                            </p>
                            <div>
                                <Label>Nombre:</Label>
                                <BlkField className="form-control" type="text" placeholder="Nombre" name="nmContacto" />
                            </div>
                            <div>
                                <Label>Correo electrónico:</Label>
                                <BlkField className="form-control" type="text" placeholder="Correo" name="correo" />
                            </div>
                        </CardBody>
                        <CardFooter className="pt-0 mt-5">
                            <div>
                                <Button
                                    type={"submit"}
                                    color="secondary"
                                    className="mb-3 py-1 text-primary btn btn-white btn-lg btn-block"
                                    onClick={submitForm}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Registrando..." : "Registrarse"}
                                </Button>
                            </div>

                            <h6 className={"text-center"}>
                                <Link to="/" className="link footer-link">
                                    Iniciar sesión
                                </Link>
                            </h6>
                        </CardFooter>
                    </Card>
                </Form>
            )}
        </BlkFormik>
    );
};

const FormValida = ({ data, onSubmitPass }) => {
    return (
        <BlkFormik initialValues={data} onSubmit={onSubmitPass} enableReinitialize={true} validateOnChange={false}>
            {({ values, isSubmitting, submitForm }) => (
                <Form className={"d-flex justify-content-end flex-column align-items-center align-items-md-end"}>
                    <Row>
                        <div className="col m-4 justify-content-center align-content-center">
                            <h4 className="m-3 text-center text-white">Registro</h4>
                            <div className="align-content-center justify-content-center text_align-center">
                                <p className="text-white m-4 text-primary ">
                                    Para terminar tu registro de forma segura, te hemos enviado un correo electrónico;
                                    favor ingresar al mismo y oprime el botón {"VALIDAR"}, o en su defecto, digita en
                                    esta pantalla
                                    <b className={"text-yellow font-weight-bold"}> el código de validación</b> que
                                    consta en dicho correo.
                                </p>
                            </div>
                        </div>
                        <Card className="card-login card-plain m-4 my-xl-auto">
                            <CardBody className={"pb-0 text-center"}>
                                <br />
                                {!values.hide && (
                                    <>
                                        <div>
                                            <Label>Código de Validación:</Label>
                                            <BlkField
                                                className="form-control"
                                                type="text"
                                                placeholder="Código de Validación "
                                                name="code"
                                            />
                                        </div>
                                    </>
                                )}
                                <div>
                                    <Label>Contraseña:</Label>
                                    <BlkField
                                        className="form-control"
                                        type="password"
                                        placeholder="Nueva Contraseña"
                                        name="passwd1"
                                        autoComplete="new-password"
                                    />
                                </div>

                                <div>
                                    <Label>Verificar Contraseña:</Label>
                                    <BlkField
                                        className="form-control"
                                        type="password"
                                        placeholder="Verificar contraseña"
                                        name="passwd2"
                                    />
                                </div>
                            </CardBody>
                            <CardFooter className="pt-0 mt-5">
                                <div>
                                    <Button
                                        block
                                        type={"submit"}
                                        color="white"
                                        className="mb-3 py-1 text-primary btn-lg"
                                        onClick={submitForm}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "Validando..." : "Validar"}
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Row>
                </Form>
            )}
        </BlkFormik>
    );
};
